import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { LinkedIn as LinkedInIcon } from '@mui/icons-material';

const LinkedIn: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        {t('marketing.linkedin')}
      </Typography>

      <Card elevation={2}>
        <CardContent sx={{ textAlign: 'center', py: 8 }}>
          <LinkedInIcon sx={{ fontSize: 120, color: '#0077B5', mb: 3 }} />
          <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#0077B5' }}>
            {t('marketing.comingSoon')}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            LinkedIn marketing features will be available soon
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LinkedIn;
